import { jwtDecode } from 'jwt-decode';

export default {
    // Système d'erreur et de validation
    changeErrorMsg(state, msg) {
        state.errorMsg = msg
    },
    changeValidationMsg(state, msg) {
        state.validationMsg = msg
    },

    // AUTHENTIFICATION
    setToken(state, token) {
        try {
            jwtDecode(token);
            state.api_token = token;
        } catch {
            state.api_token = undefined;
        }
    },
}